import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import styled from "styled-components";
import { TabsStyled } from "../tab/tab.styled";
import { DatePickerContainer } from "../saveGig/shift/shiftForm.styled";

export const ArrowSign = styled.span`
  padding: 0 10px;
  margin: 0;
  font-size: ${FontSize.H4};

  &:hover {
    background-color: ${Color.SeaBlue200};
    cursor: pointer;
  }
`;

export const MonthSelectContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  margin-top: 30px;
`;

export const Cell = styled.div`
  background-color: ${Color.White};
  margin: 10px 0;
  padding: 15px;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "workerContainer divider1"
    "grossSalaryContainer netSalaryContainer taxContainer payrollTaxContainer deductionAmountContainer taxTableContainer"
    "divider2"
    "hoursSalaryContainer"
    "divider3"
    "salaryActionContainer"
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};

  @media (min-width: 640px) {
    grid-template:
      "workerContainer divider1 grossSalaryContainer taxContainer netSalaryContainer  payrollTaxContainer deductionAmountContainer taxTableContainer divider2 hoursSalaryContainer divider3 salaryActionContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "workerContainer divider1 grossSalaryContainer taxContainer netSalaryContainer  payrollTaxContainer deductionAmountContainer taxTableContainer divider2 hoursSalaryContainer divider3 salaryActionContainer" auto
      / 3fr 1px 2fr 2fr 2fr 2fr 2fr 2fr 1px 2fr 1px 1fr auto;
  }

  p {
    margin: 0;
  }
`;

export const DividerLine1 = styled.div`
  display: none;
  background-color: ${Color.SeaBlue300};
  grid-area: divider1;

  @media (min-width: 640px) {
    display: unset;
  }
`;

export const DividerLine2 = styled.div`
  display: none;
  background-color: ${Color.SeaBlue300};
  grid-area: divider2;

  @media (min-width: 970px) {
    display: unset;
  }
`;

export const DividerLine3 = styled.div`
  display: none;
  background-color: ${Color.SeaBlue300};
  grid-area: divider3;

  @media (min-width: 970px) {
    display: unset;
  }
`;

export const WorkerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
  grid-area: workerContainer;
`;

export const GrossSalaryContainer = styled(WorkerContainer)`
  grid-area: grossSalaryContainer;
`;

export const NetSalaryContainer = styled(WorkerContainer)`
  grid-area: netSalaryContainer;
`;

export const HoursContainer = styled(WorkerContainer)`
  grid-area: hoursSalaryContainer;
`;

export const SalaryActionContainer = styled(WorkerContainer)`
  grid-area: salaryActionContainer;
  flex-direction: row;
`;

export const TaxContainer = styled(WorkerContainer)`
  grid-area: taxContainer;
`;

export const PayrollTaxContainer = styled(WorkerContainer)`
  grid-area: payrollTaxContainer;
`;

export const DeductionAmountContainer = styled(WorkerContainer)`
  grid-area: deductionAmountContainer;
`;

export const TaxTableContainer = styled(WorkerContainer)`
  grid-area: taxTableContainer;
`;

export const SalaryNoticeContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

export const SumRow = styled(SalaryNoticeContainer)``;

export const SalaryPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

type Props = {
  active: boolean;
};

export const StyledTabGroup = styled(TabsStyled)`
  margin-bottom: 40px;
`;

export const TabStyled = styled.div<Props>`
  width: 50%;
  flex-basis: 50%;
  text-align: center;
  border-bottom: ${(props) =>
    props.active
      ? `3px solid ${Color.BurntSienna}`
      : `1px solid ${Color.SeaBlue200}`};

  &:hover {
    background-color: ${Color.SeaBlue200};
    cursor: pointer;
  }
`;

type ContainerProps = {
  width?: number;
};

export const Container = styled.div<ContainerProps>`
  position: relative;
  width: ${(props) => (props.width ? `${props.width}px` : `300px`)};
`;

export const Input = styled.input`
  width: 250px;
  padding: 10px;
  border: 1px solid ${Color.Grey};
  border-radius: 4px;
  font-size: ${FontSize.Standard};
`;

export const Row = styled.div`
  display: grid;
  grid-auto-flow: column;
  width: 100%;
  align-items: center;
`;

export const DropdownList = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  max-height: 250px;
  overflow-y: auto;
  border: 1px solid ${Color.Grey};
  border-top: none;
  list-style: none;
  padding: 0;
  margin: 0;
  background: ${Color.White};
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 10;
`;

type DropDownProps = {
  isSelected: boolean;
};

export const DropdownItem = styled.li<DropDownProps>`
  padding: 10px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;

  &:hover {
    background-color: ${Color.White};
  }

  ${(props) =>
    props.isSelected &&
    `
    background-color: ${Color.White};
  `}
`;

export const WorkerId = styled.span`
  color: ${Color.DarkGrey};
  font-size: 0.8em;
`;

export const DropDownContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

export const LogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Logo = styled.img`
  height: 12px;
  width: 40px;
  margin-left: 10px;
  margin-top: 7px;
`;

export const EmptyDiv = styled.div`
  height: 12px;
  width: 40px;
  margin-left: 10px;
  margin-top: 7px;
`;

export const PdfControls = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  width: 100%;
  margin-bottom: 20px;
  margin-top: 0px;
`;

export const PDFViewerContainer = styled.div`
  display: flex;
  width: 50%;
  height: 80%;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  margin-top: 100px;
  padding: 30px;
  background-color: ${Color.White};
  margin-bottom: 50px;
`;

type ViewerProps = {
  big?: boolean;
};
export const ViewerContainer = styled(PDFViewerContainer)<ViewerProps>`
  width: ${(props) => (props.big ? "80%" : "100%")};
  height: ${(props) => (props.big ? "80%" : "auto")};
  min-height: 400px;
  margin: 10% auto;
  margin-top: ${(props) => (props.big ? "20px" : "0px")};
  background-color: white;
  border-radius: 4px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const XmlContent = styled.div`
  flex: 1;
  height: 600px;
  max-height: 600px;
  overflow: auto;
  border: 1px solid #ccc;
  padding: 10px;
  background-color: #f5f5f5;

  pre {
    margin: 0;
    white-space: pre-wrap;
    word-wrap: break-word;
    font-family: monospace;
  }
`;

/* AGI */

export const AGICell = styled.div`
  background-color: ${Color.White};
  margin: 10px 0;
  width: 95%;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "AGIWorkerContainer personalIdentityNumberContainer divider1" 1fr
    "grossContainer employerTaxContainer AGITaxContainer AGIActionContainer"
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};
  margin-left: 15px;
  margin-right: 15px;

  @media (min-width: 640px) {
    grid-template:
      "AGIWorkerContainer personalIdentityNumberContainer AGIdivider grossContainer employerTaxContainer AGITaxContainer AGIActionContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "AGIWorkerContainer personalIdentityNumberContainer AGIdivider grossContainer employerTaxContainer AGITaxContainer AGIActionContainer" auto
      / 2fr 2fr 1px 2fr 2fr 2fr 1fr auto;
  }

  p {
    margin: 0;
  }
`;

export const AGIBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
`;

export const AGITaxContainer = styled(WorkerContainer)`
  grid-area: AGITaxContainer;
`;

export const AGIWorkerContainer = styled(WorkerContainer)`
  grid-area: AGIWorkerContainer;
`;

export const EmployerTaxContainer = styled(WorkerContainer)`
  grid-area: employerTaxContainer;
`;

export const GrossContainer = styled(WorkerContainer)`
  grid-area: grossContainer;
`;

export const PersonalIdentityNumberContainer = styled(WorkerContainer)`
  grid-area: personalIdentityNumberContainer;
`;

export const AGIPageContainer = styled.div`
  background-color: ${Color.White};
`;

export const AGIDivider = styled.div`
  display: none;
  background-color: ${Color.SeaBlue300};
  grid-area: AGIdivider;
  height: 50px;
  margin-bottom: 10px;

  @media (min-width: 640px) {
    display: unset;
  }
`;

export const AGIActionContainer = styled(WorkerContainer)`
  grid-area: AGIActionContainer;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

/* ---- */

/* Absence */

type AbsenceProps = {
  lastRow: boolean;
};

export const AbsenceRow = styled.div<AbsenceProps>`
  background-color: ${Color.White};
  margin: 10px 0;
  width: 95%;
  display: grid;
  padding: 10px;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "AbsenceDateContainer AbsenceTypeContainer AbsenceHoursContainer" 1fr
    / 1fr auto;

  border-bottom: ${(props) =>
    props.lastRow ? "none" : `1px solid ${Color.SeaBlue200}`};

  @media (min-width: 640px) {
    grid-template:
      "AbsenceDateContainer AbsenceTypeContainer AbsenceHoursContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "AbsenceDateContainer AbsenceTypeContainer AbsenceHoursContainer" auto
      / 2fr 2fr 2fr auto;
  }

  p {
    margin: 0;
  }
`;

export const AbsenceDateContainer = styled(WorkerContainer)`
  grid-area: AbsenceDateContainer;
`;
export const AbsenceTypeContainer = styled(WorkerContainer)`
  grid-area: AbsenceTypeContainer;
`;
export const AbsenceHoursContainer = styled(WorkerContainer)`
  grid-area: AbsenceHoursContainer;
`;

export const AbsenceContainer = styled.div`
  display-flex: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-bottom: 15px;
`;

/* ----- */

/* PayOutDetails */

type PayoutProps = {
  lastRow: boolean;
};

export const PayoutRow = styled.div<PayoutProps>`
  background-color: ${Color.White};
  margin: 10px 0;
  width: 95%;
  display: grid;
  padding: 10px;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "PayoutDescriptionContainer PayoutPeriodContainer PayoutGrossContainer PayoutExployerTaxContainer PayoutWorkerTaxContainer" 1fr
    / 1fr auto;

  border-bottom: ${(props) =>
    props.lastRow ? "none" : `1px solid ${Color.SeaBlue200}`};

  @media (min-width: 640px) {
    grid-template:
      "PayoutDescriptionContainer PayoutPeriodContainer PayoutGrossContainer PayoutExployerTaxContainer PayoutWorkerTaxContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "PayoutDescriptionContainer PayoutPeriodContainer PayoutGrossContainer PayoutExployerTaxContainer PayoutWorkerTaxContainer" auto
      / 3fr 2fr 2fr 2fr 2fr auto;
  }

  p {
    margin: 0;
  }
`;

export const PayoutDescriptionContainer = styled(WorkerContainer)`
  grid-area: PayoutDescriptionContainer;
`;
export const PayoutPeriodContainer = styled(WorkerContainer)`
  grid-area: PayoutPeriodContainer;
`;
export const PayoutGrossContainer = styled(WorkerContainer)`
  grid-area: PayoutGrossContainer;
`;

export const PayoutExployerTaxContainer = styled(WorkerContainer)`
  grid-area: PayoutExployerTaxContainer;
`;
export const PayoutWorkerTaxContainer = styled(WorkerContainer)`
  grid-area: PayoutWorkerTaxContainer;
`;

export const PayoutContainer = styled.div`
  display-flex: flex;
  flex-direction: column;
  margin-bottom: 15px;
  margin-left: 5px;
`;

/* ---- */

export const SwitcherContainer = styled.div`
  display: inline-flex;
  background-color: #f1f5f9;
  border-radius: 10px;
  padding: 2px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  margin-left: 10px;
`;

export const SwitcherButton = styled.button<{
  $active: boolean;
  $disabled?: boolean;
}>`
  border: none;
  background-color: ${(props) => (props.$active ? "white" : "transparent")};
  color: ${(props) =>
    props.$disabled
      ? Color.Grey
      : props.$active
      ? Color.MidnightBlue
      : Color.Grey};
  font-size: 14px;
  font-family: ${(props) =>
    props.$active ? FontFamily.MontserratBold : FontFamily.MontserratRegular};
  padding: 8px 16px;
  border-radius: 10px;
  cursor: ${(props) => (props.$disabled ? "not-allowed" : "pointer")};
  transition: all 0.2s ease;
  box-shadow: ${(props) =>
    props.$active ? "0 1px 2px rgba(0, 0, 0, 0.1)" : "none"};

  &:focus {
    outline: none;
  }
`;

export const ViewSwitcherContainer = styled.div`
  margin-left: 70px;
  width: 100%;
  display: flex;
  flex-direction: row;
`;

export const FileViewerContainer = styled.div`
  height: 700px;
  padding: 0px;
  margin: 0px;
`;

/* Edit month modal */

export const MonthListItem = styled.div`
  background-color: ${Color.White};
  margin: 10px 0;
  width: 95%;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 10px;
  grid-template:
    "monthContainer monthHoursContainer" 1fr
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};
  margin-left: 10px;

  @media (min-width: 640px) {
    grid-template:
      "monthContainer monthHoursContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "monthContainer monthHoursContainer" auto
      / 3fr 2fr;
  }

  p {
    margin: 0;
  }
`;

export const MonthContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
  grid-area: monthContainer;
`;

export const MonthHoursContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
  grid-area: monthHoursContainer;
`;

export const HoursActionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

export const ModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
  p {
    margin: 0 0 30px 0;
  }
`;

export const EditHoursModalBody = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: auto;
  background-color: ${Color.White};
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  outline: none;
  border-radius: 8px;
  max-height: 90vh;
  box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
  overflow-y: auto;
  p {
    margin: 0 0 30px 0;
  }
`;

/* Month salaires */

export const MonthSalaryBody = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

export const MonthOverviewActionContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0px;
  justify-content: space-between;
`;

export const MonthOverviewButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
export const MonthSalaryPageContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

type MonthSalaryProps = {
  isInactive?: boolean;
};

export const MonthSalaryCell = styled.div<MonthSalaryProps>`
  opacity: ${(props) => (props.isInactive ? 0.6 : 1)};
  background-color: ${Color.White};
  margin: 10px 0;
  padding: 15px;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  margin-top: 20px;
  grid-template:
    "firstContainer divider1"
    "secondContainer thirdContainer fourthContainer fifthContainer sixthContainer divider2 seventhContainer"
    / 1fr auto;

  border-bottom: 1px solid ${Color.SeaBlue200};

  @media (min-width: 640px) {
    grid-template:
      "firstContainer divider1 secondContainer thirdContainer fourthContainer  fifthContainer sixthContainer divider2 seventhContainer" auto
      / 1fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "firstContainer divider1 secondContainer thirdContainer fourthContainer fifthContainer sixthContainer divider2 seventhContainer" auto
      / 3fr 1px 2fr 2fr 2fr 2fr 1fr 1px 1fr auto;
  }

  p {
    margin: 0;
  }
`;

export const FirstContainer = styled(WorkerContainer)`
  grid-area: firstContainer;
`;

export const SecondContainer = styled(WorkerContainer)`
  grid-area: secondContainer;
`;

export const ThirdContainer = styled(WorkerContainer)`
  grid-area: thirdContainer;
`;

export const FourthContainer = styled(WorkerContainer)`
  grid-area: fourthContainer;
`;

export const FifthContainer = styled(WorkerContainer)`
  grid-area: fifthContainer;
`;

export const SeventhContainer = styled(WorkerContainer)`
  grid-area: seventhContainer;
  flex-direction: row;
`;

export const SixthContainer = styled(WorkerContainer)`
  grid-area: sixthContainer;
`;

export const FuturePastSalaryListItem = styled.div<AbsenceProps>`
  background-color: ${Color.White};
  margin: 0 auto;
  width: 95%;
  display: grid;
  padding: 10px;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template:
    "firstContainer divider1 secondContainer thirdContainer" 1fr
    / 1.5fr 1px 2fr 2fr auto;

  border-bottom: ${(props) =>
    props.lastRow ? "none" : `1px solid ${Color.SeaBlue200}`};

  @media (min-width: 640px) {
    grid-template:
      "firstContainer divider1 secondContainer thirdContainer" auto
      / 1.5fr 1px 2fr 2fr auto;
  }

  @media (min-width: 970px) {
    grid-template:
      "firstContainer divider1 secondContainer thirdContainer" auto
      / 1.5fr 1px 2fr 2fr auto;
  }

  p {
    margin: 0;
  }
`;

export const FuturePastSalaryContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0px;
`;

type DatePickerProps = {
  focused: boolean;
};

export const SingleDatePickerContainer = styled(
  DatePickerContainer
)<DatePickerProps>`
  .DateInput_input {
    background-color: ${Color.SeaBlue200};
    border: none;
    font-family: ${FontFamily.MontserratSemiBold};
    color: ${Color.MidnightBlue};
    font-size: 14px;
    text-align: center;
    border-radius: 10px;
    padding: 5px;
    margin-top: 10px;
  }

  #SingleDatePicker {
    ${(props) => (props.focused ? "margin-bottom: 300px" : "10px")};
  }
`;

/* UpdateSalaryContainer */

export const UpdateSalaryContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const TooltipModal = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 300px;
  background-color: ${Color.White};
  padding: 12px 16px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  border: 1px solid ${Color.LightGrey02};
  z-index: 1000;

  &::before {
    content: "";
    position: absolute;
    top: -8px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${Color.White};
  }

  &::after {
    content: "";
    position: absolute;
    top: -9px;
    right: 20px;
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-bottom: 8px solid ${Color.LightGrey02};
  }
`;

export const TooltipContainer = styled.div`
  position: relative;
  display: inline-block;
  margin-left: auto;
`;

export const LinkWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  div {
    margin: 0 0 10px 0;
  }
`;

/* Salary Exports */
export const ExportGrid = styled.div`
  width: 100%;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;

  column-gap: 60px;  
  row-gap: 20px;     

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    column-gap: 0;  
  }
`;

export const ExportCell = styled.div`
  background-color: ${Color.White};
  margin: 10px 0;
  width: 100%; 
  padding: 15px;
  display: grid;
  grid-row-gap: 10px;
  grid-column-gap: 20px;
  grid-template: "left divider1 right" / 1fr 1px 3fr;
  border-bottom: 1px solid ${Color.SeaBlue200};

  p {
    margin: 0;
  }
`;
export const ExportContainerLeft = styled(WorkerContainer)`
  grid-area: left;
`;

export const ExportContainerRight = styled(WorkerContainer)`
  grid-area: right;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;
